export interface PermitOffice {
  /** Municipality or authority that issues building permits for this area. */
  name: string;
  /** Official permit information URL. */
  url: string;
}

// Official municipal permit pages mapped to each town slug. Some towns span more
// than one municipality, so a single town page may reference multiple offices.
// Source: town-by-town permit office list provided by the client.
export const permitOfficesBySlug: Record<string, PermitOffice[]> = {
  "chester-springs": [
    { name: "Upper Uwchlan Township", url: "https://www.upperuwchlan-pa.gov/197/Construction-Activities-Requiring-a-Perm" },
    { name: "West Pikeland Township", url: "https://www.westpikeland.com/permits" },
    { name: "West Vincent Township", url: "https://westvincenttwp.org/permit-application-process/" },
  ],
  "berwyn": [
    { name: "Easttown Township", url: "https://www.easttown.org/279/Permits" },
    { name: "Tredyffrin Township", url: "https://www.tredyffrin.org/Departments/Permits-Inspections/Building-Construction-Permits" },
  ],
  "devon": [
    { name: "Easttown Township", url: "https://www.easttown.org/279/Permits" },
  ],
  "malvern": [
    { name: "Malvern Borough", url: "https://www.malvern.org/1316/Permits-and-Applications" },
  ],
  "chesterbrook": [
    { name: "Tredyffrin Township", url: "https://www.tredyffrin.org/Departments/Permits-Inspections/Building-Construction-Permits" },
  ],
  "exton": [
    { name: "West Whiteland Township", url: "https://www.westwhiteland.org/408/Permit-Applications" },
  ],
  "west-chester": [
    { name: "West Chester Borough", url: "https://west-chester.com/862/Building-Permits" },
  ],
  "downingtown": [
    { name: "Downingtown Borough", url: "https://www.downingtown.org/162/FormsApplications" },
  ],
  "glenmoore": [
    { name: "Wallace Township", url: "https://www.wallacetownship.org/zoning" },
  ],
  "kennett-square": [
    { name: "Kennett Square Borough", url: "https://www.kennettsq.org/departments/codes_zoning/forms_and_permits.php" },
  ],
  "unionville": [
    { name: "East Marlborough Township", url: "https://www.eastmarlborough.org/permits/" },
  ],
  "elverson": [
    { name: "Elverson Borough", url: "https://elversonboro.org/services/permit-packet/" },
  ],
  "morgantown": [
    { name: "Caernarvon Township", url: "https://www.caernarvon.org/government/building_permits/permit_applications.php" },
  ],
  "honey-brook": [
    { name: "Honey Brook Borough", url: "https://honeybrookborough.net/forms/" },
    { name: "Honey Brook Township", url: "https://www.honeybrooktwp.com/administrative-department/page/construction-demolition-permit-applications" },
  ],
  "lititz": [
    { name: "Lititz Borough", url: "https://www.lititzborough.org/1195/ZoningCode-Enforcement" },
  ],
  "landisville": [
    { name: "East Hempfield Township", url: "https://easthempfield.org/departments/development_services/building_zoning.php" },
  ],
  "east-petersburg": [
    { name: "East Petersburg Borough", url: "https://eastpetersburgborough.org/forms-documents/" },
  ],
  "mount-joy": [
    { name: "Mount Joy Borough", url: "https://mountjoyborough.com/permits/permit-forms/" },
  ],
  "manheim": [
    { name: "Manheim Borough", url: "https://www.manheimboro.org/1194/Zoning-Codes" },
  ],
  "millersville": [
    { name: "Millersville Borough", url: "https://millersvilleborough.org/code-enforcement-zoning/" },
  ],
  "strasburg": [
    { name: "Strasburg Borough", url: "https://strasburgboro.org/departments/zoning-and-code-enforcement/" },
  ],
  "hershey": [
    { name: "Derry Township", url: "https://www.derrytownship.org/resident-services/building-permits" },
  ],
  "hummelstown": [
    { name: "Hummelstown Borough", url: "https://hummelstown.gov/codes-zoning" },
  ],
  "camp-hill": [
    { name: "Camp Hill Borough", url: "https://www.camphillborough.com/departments/codes_enforcement___zoning/building_permits.php" },
  ],
  "mechanicsburg": [
    { name: "Mechanicsburg Borough", url: "https://www.mechanicsburgpa.org/services/codes___zoning_enforcement/index.php" },
  ],
  "dillsburg": [
    { name: "Dillsburg Borough", url: "https://dillsburg.com/building-zoning-permit-information/" },
  ],
  "wyomissing": [
    { name: "Borough of Wyomissing", url: "https://wyomissingboro.org/169/Permits-Zoning-Codes-Enforcement" },
  ],
  "sinking-spring": [
    { name: "Borough of Sinking Spring", url: "https://sinkingspringboro.org/documents/permit-information" },
  ],
  "wernersville": [
    { name: "Wernersville Borough", url: "https://kraftmunicipalgroup.com/wp-content/uploads/2024/02/Wernersville-Borough_General-Info_2024.pdf" },
  ],
  "columbia": [
    { name: "Columbia Borough", url: "https://www.columbiapa.net/departments/planning/permit_applications.php" },
  ],
  "manheim-township": [
    { name: "Manheim Township", url: "https://www.manheimtownship.org/1210/Roofing-Siding-Windows-Doors" },
  ],
  "lancaster": [
    { name: "City of Lancaster", url: "https://www.cityoflancasterpa.gov/services/permits-licensing/" },
  ],
  "ephrata": [
    { name: "Ephrata Borough", url: "https://ephrataboro.org/2200/Permits" },
  ],
  "elizabethtown": [
    { name: "Elizabethtown Borough", url: "https://www.etownonline.com/1205/Planning-Zoning" },
  ],
  "new-holland": [
    { name: "New Holland Borough", url: "https://newhollandborough.org/building-permit-info/" },
  ],
  "leola": [
    { name: "Upper Leacock Township", url: "https://www.ultwp.com/zoning" },
    { name: "Leacock Township", url: "https://www.leacocktwp.com/1196/Files-Forms" },
  ],
  "willow-street": [
    { name: "West Lampeter Township", url: "https://westlampeter.com/2150/Building-Permits" },
  ],
  "quarryville": [
    { name: "Quarryville Borough", url: "https://quarryvilleborough.com/government/zoning-and-building/" },
  ],
  "denver": [
    { name: "Denver Borough", url: "https://www.denverboro.net/page/departments" },
  ],
  "marietta": [
    { name: "Marietta Borough", url: "https://boroughofmarietta.com/documents/" },
  ],
  "gladwyne": [
    { name: "Lower Merion Township", url: "https://www.lowermerion.org/" },
  ],
  "villanova": [
    { name: "Radnor Township", url: "https://www.radnor.org/" },
    { name: "Lower Merion Township", url: "https://www.lowermerion.org/" },
  ],
  "bryn-mawr": [
    { name: "Lower Merion Township", url: "https://www.lowermerion.org/" },
    { name: "Radnor Township", url: "https://www.radnor.org/" },
  ],
  "haverford": [
    { name: "Haverford Township", url: "https://www.haverfordtownship.org/" },
    { name: "Lower Merion Township", url: "https://www.lowermerion.org/" },
  ],
  "wayne": [
    { name: "Radnor Township", url: "https://www.radnor.org/" },
    { name: "Tredyffrin Township", url: "https://www.tredyffrin.org/Departments/Permits-Inspections/Building-Construction-Permits" },
  ],
  "lower-merion": [
    { name: "Lower Merion Township", url: "https://www.lowermerion.org/" },
  ],
  "wynnewood": [
    { name: "Lower Merion Township", url: "https://www.lowermerion.org/" },
  ],
  "narberth": [
    { name: "Narberth Borough", url: "https://www.narberthpa.gov/permits" },
  ],
  "bala-cynwyd": [
    { name: "Lower Merion Township", url: "https://www.lowermerion.org/" },
  ],
  "doylestown": [
    { name: "Doylestown Borough", url: "https://www.doylestownborough.net/" },
    { name: "Doylestown Township", url: "https://www.doylestownpa.org/" },
  ],
  "new-hope": [
    { name: "New Hope Borough", url: "https://www.newhopeborough.org/" },
  ],
  "washington-crossing": [
    { name: "Upper Makefield Township", url: "https://www.uppermakefield.org/" },
  ],
  "newtown": [
    { name: "Newtown Borough", url: "https://newtownboro.com/" },
    { name: "Newtown Township", url: "https://www.newtownpa.gov/" },
  ],
  "furlong": [
    { name: "Buckingham Township", url: "https://www.buckinghampa.org/" },
  ],
  "richboro": [
    { name: "Northampton Township", url: "https://www.northamptontownship.com/" },
  ],
  "dresher": [
    { name: "Upper Dublin Township", url: "https://www.upperdublin.net/" },
  ],
  "blue-bell": [
    { name: "Whitpain Township", url: "https://www.whitpaintownship.org/" },
  ]
};
